<template>
  <div class="animated fadeIn">
    <SubHeaderReview/>
    <DataTable :editable="editable" :eventStatus="'review'"/>
  </div>
</template>

<script>
import data from '../_data';
import SubHeaderReview from '../components/subHeaders/SubHeaderReview';
import DataTable from '../components/datatable/DataTable';
import consts from '../_consts';

export default {
  name: 'review',
  components: {
    SubHeaderReview,
    DataTable
  },
  data () {
    return {
      list: data.items,
      currentPage: 1,
      perPage: 5,
      totalRows: data.items.length,
      pageOptions: [
        { text: 5, value: 5 },
        { text: 10, value: 10 },
        { text: 15, value: 15 }
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' }
    };
  },
  methods: {
    details (item, index, button) {
      this.modalDetails.data = JSON.stringify(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    },
    resetModal () {
      this.modalDetails.data = '';
      this.modalDetails.index = '';
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },
  computed: {
    editable () {
      return localStorage.getItem(consts.LOCAL_STORE.role) !== consts.USER_ROLE.eventManager && !(localStorage.getItem(consts.LOCAL_STORE.readOnly) === 'true');
    }
  }
};
</script>
<style>
.textHeader {
  height: 17px;
  width: 37px;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 10px;
  line-height: 17px;
}

tbody {
  background-color: #ffffff;
}

.table thead th {
  height: 37px;
  background-color: #231F20;
}

table.b-table tfoot>tr>.sorting:after,
table.b-table tfoot>tr>.sorting:before,
table.b-table thead>tr>.sorting:after,
table.b-table thead>tr>.sorting:before {
  background-color: #ffffff;
}

table.b-table>tfoot>tr>.sorting:after,
table.b-table>thead>tr>.sorting:after {
  background-color: #ffffff;
}
</style>




// WEBPACK FOOTER //
// Review.vue?138f4899